import SearchFilter from "./SearchFilter";
import DatePicker from "react-datepicker";
import moment from "moment";
import { HStack, Wrap } from "../../../../styled-system/jsx";
import { ButtonGroup } from "../../core/basic/ButtonGroup";
import { css } from "../../../../styled-system/css";

const FilterBar = ({
  selectedSearchId,
  shelfData,
  selectedShelf,
  filterSearchId,
  selectedRollupType,
  filterRollupType,
  dateRange: [start, end],
  setSelectedDateRange,
  isLoading,
}) => {
  return (
    <>
      <Wrap justify={"space-between"}>
        <ButtonGroup
          buttons={[
            {
              value: "page_1",
              label: "Page 1",
            },
            {
              value: "above_fold",
              label: "Above Fold",
            },
          ]}
          value={selectedRollupType}
          onSelect={filterRollupType}
        />

        <HStack gap="medium">
          <DatePicker
            placeholderText={"Start"}
            onChange={(d) => {
              setSelectedDateRange([moment(d), end]);
            }}
            selected={start.toDate()}
          />
          <span className={css({ fontSize: "medium", fontWeight: "bolder" })}>to</span>
          <DatePicker
            placeholderText={"End"}
            onChange={(d) => {
              setSelectedDateRange([start, moment(d)]);
            }}
            selected={end.toDate()}
          />
        </HStack>

        <SearchFilter
          shelfData={shelfData}
          filterSearchId={filterSearchId}
          selectedShelf={selectedShelf}
          selectedSearchId={selectedSearchId}
        />
      </Wrap>
      <div>
        {isLoading && (
          <>
            <i className="fa fa-spin fa-circle-o-notch" /> Loading
          </>
        )}
      </div>
    </>
  );
};

export default FilterBar;
